module.exports = __webpack_public_path__ + "img/button-text-block-quote-on.29ea1c9.svg";